import React from "react";
import BuyerUserListItem from "../../components/buyerUser/BuyerUserList/BuyerUserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const BuyerUserListPage = ()  => {

    useTitle(t`List Buyer User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <BuyerUserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default BuyerUserListPage;
